import { render, staticRenderFns } from "./AssignmentAiSection.vue?vue&type=template&id=0240344c&scoped=true&"
import script from "./AssignmentAiSection.vue?vue&type=script&lang=js&"
export * from "./AssignmentAiSection.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentAiSection.vue?vue&type=style&index=0&id=0240344c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0240344c",
  null
  
)

export default component.exports